import { Classes } from '@blueprintjs/core';
import { NoiseEventPolicy, NoiseEventPolicyOverrideEnum } from 'app/__generated__/global';
import { KnownAccessControls } from 'app/business-logic/security/KnownAccessControls';
import { FormikReactSelectControl } from 'app/components/formik-controls';
import { AccessControlGate } from 'app/routing/access-control-gate';
import { useI18n } from 'core/hooks/useI18n';
import { useFormikContext } from 'formik';
import { EventApprovalHeading, NoisePolicySelectWrapper, SelectWrapper } from './EventApproval.styles';
import { EventApprovalFormValues } from './EventApproval.types';

export const EventApproval = ({ isLoading }: { isLoading: boolean }) => {
  const { l10n } = useI18n('app/views/alerts', 'eventApproval');
  const {
    values: { noiseEventPolicyOverride },
  } = useFormikContext<EventApprovalFormValues>();
  if (!noiseEventPolicyOverride.length) return null;
  return (
    <AccessControlGate requires={KnownAccessControls.app.config.resourceGroups._}>
      <EventApprovalHeading>{l10n('heading')}</EventApprovalHeading>
      <NoisePolicySelectWrapper>
        {noiseEventPolicyOverride.map(({ resourceGroupId, resourceGroupName, defaultNoiseEventPolicy }, index) => {
          const options = [
            {
              label: getDefaultLabel(l10n, defaultNoiseEventPolicy),
              value: NoiseEventPolicyOverrideEnum.Default,
            },
            { label: l10n('options.disabled'), value: NoiseEventPolicyOverrideEnum.Disabled },
            { label: l10n('options.enabled'), value: NoiseEventPolicyOverrideEnum.Enabled },
          ];
          return (
            <SelectWrapper key={resourceGroupId} className={isLoading ? Classes.SKELETON : undefined}>
              <FormikReactSelectControl
                name={`noiseEventPolicyOverride.${index}.override`}
                label={resourceGroupName}
                data={options}
                textField="label"
                valueField="value"
                isDisabled={isLoading}
                menuPortalTarget={document.body}
              />
            </SelectWrapper>
          );
        })}
      </NoisePolicySelectWrapper>
    </AccessControlGate>
  );
};

const getDefaultLabel = (l10n: (key: string) => string, defaultNoiseEventPolicy: NoiseEventPolicy | null) => {
  const defaultLabel = l10n('options.default');
  if (defaultNoiseEventPolicy === NoiseEventPolicy.DefaultEnabled) {
    return `${defaultLabel} (${l10n('options.allEvents')})`;
  }
  return `${defaultLabel} (${l10n('options.noEvents')})`;
};
